module.exports = __webpack_public_path__ + "img/invoice-de-female-wm-sh.d5046d7a.png";